import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { StoreRedirectOnLoginService } from '@app/core/_services/store-redirect-on-login.service'
import { FeatureCheckService } from '@app/core/_services/feature-check.service'
import { UserService } from '@app/core/_services/user.service'
import { Observable, of } from 'rxjs'
import { filter, map, switchMap, take } from 'rxjs/operators'

@Injectable({
    providedIn: 'root',
})
export class GroupMeetingsFeatureGuard {
    constructor(
        private router: Router,
        private userService: UserService,
        private featureCheckService: FeatureCheckService,
        private storeRedirectOnLoginService: StoreRedirectOnLoginService,
    ) {}

    canActivate(
        _route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> {
        return this.userService.isAuthenticated.pipe(
            take(1),
            switchMap((authenticated) => {
                if (!authenticated) {
                    this.storeRedirectOnLoginService.setUrlToRedirectToOnLogin(state.url)
                    return of(this.router.createUrlTree(['/login']))
                }

                return this.userService.currentUser.pipe(
                    filter((user) => !!user?.userId),
                    take(1),
                    map((user) => {
                        if (this.featureCheckService.isGroupMeetingsEnabled(user)) {
                            return true
                        }

                        return this.router.createUrlTree(['/dashboard'])
                    }),
                )
            }),
        )
    }
}
